import { render, staticRenderFns } from "./TransferenciaSedes.vue?vue&type=template&id=4e8663dd"
import script from "./TransferenciaSedes.vue?vue&type=script&lang=js"
export * from "./TransferenciaSedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports